import { createContext, useContext, useState } from "react";

// Create Context
const CustomBottlerContext = createContext();

// Context Provider Component
export const CustomBottlerProvider = ({ children }) => {
  const [customSelectedData, setCustomSelectedData] = useState([]);

  return (
    <CustomBottlerContext.Provider
      value={{ customSelectedData, setCustomSelectedData }}
    >
      {children}
    </CustomBottlerContext.Provider>
  );
};

// Custom Hook for easy access
export const useCustomBottler = () => useContext(CustomBottlerContext);
